import {EQWorkOrder} from "../workOrder/EQWorkOrder";

export interface EQSpecification {
  // DBField
  uid: number;
  companyUID: number; // ----------------------------- 2020.01-08 추가 됨
  departmentUID: number; // ----------------------------- 2020.01-08 추가 됨 - 미사용중

  installLocation: string; // required 설치위치
  personName: string; // 설비책임자
  type: number; // 설비 분류
  identifyNumber: string; // required 설비 번호
  name: string; // required 설비명
  manufacture: string; // 제작사
  modelNo: string; // Model
  serialNo: string; // SER.NO
  price: number; // 금액
  capacity: string; // 용량
  isPSM: boolean; // PSM유무
  eqLevel: string; // 설비등급
  law: string; // 법적대상
  checkTerm: string; // deprecated 점검주기  - 아래로 대체됨 ------------------ NOT USED
  checkTermMonth: number; // 점검주기 - 월단위
  nextDate: Date | string; // 점검도래일 - 점검기준일로 변경
  installDate: Date | string; // 설치일자
  wideLevel: string; // 방폭등급
  drivePressure: string; // 운전(압력)
  designPressure: string; // 설계(압력)
  pressure1Unit: number; // 압력단위
  pressure2Unit: number; // 압력단위

  driveTemperature: string; //운전(온도)
  designTemperature: string; //설계(온도)

  hasReliability: boolean; // 신뢰성 확인
  lifeTime: number; // 설비 수명
  daysOfWork: number; // 0 - 연 매일 24시간, 1~7 - 주 1~7일
  workHoursForDay: number; // 일 가동시간

  // Attachments
  processDocument: string;
  certification: string;
  pAndID: string;
  picture: string;

  email: string;

  entryDate: Date | string;
  modifyDate: Date | string;

  creatorUID: number; // 작성자 UID - Import한 사람도 해당됨
  officerUID: number; // 할당된 담당자 UID

  isDeleted: boolean;

  managerUID: number; // deprecated-------------------------------- 필요없어짐
  modifierUID: number; // deprecated------------------------------- 필요없어짐
  modifierLevel: number; // deprecated------------------------------- 필요없어짐 // ----------- NOTUSED

  // NOTDB
  // Base64s
  creatorName: string; // 작성자 명
  officerName: string; // 담당자 명
  processDocumentBase64: string;
  certificationBase64: string;
  pAndIDBase64: string;
  pictureBase64: string;
  workOrderList: EQWorkOrder[];

  // 신뢰도
  workHours: number; // 가동시간
  totalOrderCount: number; // 고장횟수
  totalRepairHours: number; // 총 수리시간
  mttr: number; // MTTR
  mtbf: number; // 평균고장간격(MTBF)
}

export const initialSpecification: EQSpecification = {
  // DBField
  uid: 0,
  companyUID: 0, // ----------------------------- 2020.01-08 추가 됨
  departmentUID: 0, // ----------------------------- 2020.01-08 추가 됨 - 미사용중

  installLocation: "", // 설치위치
  personName: "", // 설비책임자
  type: 0, // 설비 분류
  identifyNumber: "", // 설비 번호
  name: "", // 설비명
  manufacture: "", // 제작사
  modelNo: "", // Model
  serialNo: "", // SER.NO
  price: 0, // 금액
  capacity: "", // 용량
  isPSM: false, // PSM유무
  eqLevel: "", // 설비등급
  law: "", // 법적대상
  checkTerm: "", // deprecated 점검주기 - 아래로 대체됨 ------------------ NOT USED
  checkTermMonth: 6, // 점검주기 - 월단위
  nextDate: new Date(), // 점검도래일 - 점검기준일로 변경
  installDate: new Date(), // 설치일자
  wideLevel: "", // 방폭등급
  drivePressure: "", // 운전(압력)
  designPressure: "", // 설계(압력)
  pressure1Unit: 0, // 압력단위
  pressure2Unit: 0, // 압력단위

  driveTemperature: "", //운전(온도)
  designTemperature: "", //설계(온도)

  hasReliability: false, // 신뢰성 확인
  lifeTime: 1, // 설비 수명
  daysOfWork: 0, // 0 - 연 매일 24시간, 1~7 - 주 1~7일
  workHoursForDay: 6, // 일 가동시간

  // Attachments
  processDocument: "",
  certification: "",
  pAndID: "",
  picture: "",

  email: "",

  entryDate: new Date(),
  modifyDate: new Date(),

  creatorUID: 0, // 작성자 UID - Import한 사람도 해당됨
  officerUID: 0, // 할당된 담당자 UID

  isDeleted: false,

  managerUID: 0, // deprecated-------------------------------- 필요없어짐
  modifierUID: 0, // deprecated------------------------------- 필요없어짐
  modifierLevel: 0, // deprecated------------------------------- 필요없어짐 // ----------- NOTUSED

  // NOTDB
  creatorName: "",
  officerName: "",
  // Base64s
  processDocumentBase64: "",
  certificationBase64: "",
  pAndIDBase64: "",
  pictureBase64: "",

  workOrderList: [] as EQWorkOrder[],

  // 신뢰도
  workHours: 0, // 가동시간
  totalOrderCount: 0, // 고장횟수
  totalRepairHours: 0, // 총 수리시간
  mttr: 0, // MTTR
  mtbf: 0, // 평균고장간격(MTBF)
};

export interface EquipmentListParams {
  page: number; // 페이지
  token: string; // 사용자 토큰
  type: number; // 설비 분류
  identifyNumber: string; // 설비번호
  name: string; // 설비명
  level: string; // 설비등급
  creator: string; // 작성자
  eqLevel?: string; // 설비등급
  rows?: number; // 표시 행 수
}

export const initialEquipmentListParams: EquipmentListParams = {
  page: 1, // 페이지
  token: "", // 사용자 토큰
  type: -1, // 설비 분류
  identifyNumber: "", // 설비번호
  name: "", // 설비명
  level: "", // 설비등급
  creator: "", // 작성자
  eqLevel: "", // 설비등급
  rows: 20,
};

export interface ReliabilityParams {
  // note /API/Reliability
  page: number; // 페이지
  token: string; // 사용자 토큰
  rows?: number; // 표시 행 수
}

export const initialReliabilityParams = {
  page: 1,
  token: "",
  rows: 20,
};
